import injection from '../../../../assets/images/iniekcje.jpg';
import iglowanie from '../../../../assets/images/suche_iglowanie.jpg';

const BlogData = [
     {
        'img': injection,
        'url':'#zabiegi-lecznicze-i-przeciwbolowe',
        'title':'Leczenie ortobiologiczne',
        'description':'Leczenie ortobiologiczne jest jednym z głównych nurtów rozwoju rehabilitacji i stanowi pomoc w procesie leczenia bólu i rekonwalescencji po urazach i leczeniu operacyjnym.',
    },
    {
        'img': iglowanie,
        'url':'#zabiegi-lecznicze-i-przeciwbolowe',
        'title':'Suche igłowanie',
        'description':'Igłoterapia sucha to metoda terapeutyczna, małoinwazyjna, która znajduje zastosowanie u pacjentów z przewlekłym i ostrym bólem w mięśniowo-powięziowych punktach spustowych (tzw. trigger points).',
    }
];

export default BlogData;